module.exports = __webpack_public_path__ + "static/media/flag-ru.2fd8685b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flag-ru.svg
// module id = 846
// module chunks = 7